import { ThemeDefinition } from 'vuetify';

export const geography: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#56A3D7',
    'on-subject-original': '#FFFFFF',
    subject: '#21618C',
    'on-subject': '#FFFFFF',
    primary: '#1F5C84',
    'on-primary': '#FFFFFF',
    'primary-container': '#C1DDF0',
    'on-primary-container': '#0C2232',
    secondary: '#455A68',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D1DAE0',
    'on-secondary-container': '#182025',
    surface: '#F7FAFC',
    'on-surface': '#1D1F20',
    'on-surface-medium': '#494D50',
    'on-surface-low': '#949A9E',
    outline: '#798186',
    'outline-variant': '#C9CDCF',
    'inverse-surface': '#243642',
    'inverse-on-surface': '#EEF3F6',
    'inverse-primary': '#ACD2EC',
    'surface-dim': '#C2DAEB',
    'surface-bright': '#FBFDFE',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0F6FA',
    'surface-container': '#E8F1F7',
    'surface-container-high': '#D9E8F2',
    'surface-container-highest': '#D1E3F0',
  },
};

export const geographyDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#56A3D7',
    'on-subject-original': '#F7FAFC',
    subject: '#7FBAE1',
    'on-subject': '#0C2232',
    primary: '#B1D5ED',
    'on-primary': '#0C2232',
    'primary-container': '#1D567C',
    'on-primary-container': '#EAF4FA',
    secondary: '#C5D0D8',
    'on-secondary': '#182025',
    'secondary-container': '#3D505C',
    'on-secondary-container': '#F0F3F5',
    surface: '#101518',
    'on-surface': '#F2F2F3',
    'on-surface-medium': '#C9CDCF',
    'on-surface-low': '#798186',
    outline: '#949A9E',
    'outline-variant': '#61676B',
    'inverse-surface': '#DEE7ED',
    'inverse-on-surface': '#152028',
    'inverse-primary': '#133953',
    'surface-dim': '#0E1315',
    'surface-bright': '#2F3D46',
    'surface-container-lowest': '#0C1012',
    'surface-container-low': '#141B1F',
    'surface-container': '#1B2228',
    'surface-container-high': '#232D34',
    'surface-container-highest': '#2D3A43',
  },
};
